import Vue from 'vue';
import Vuex from 'vuex';
import { isUserLoggedIn } from '@/helpers/helpers';

Vue.use(Vuex);
export const store = new Vuex.Store({
  state: {
    isAuthenticated: isUserLoggedIn(),
    iFrameParentUrl: parent !== window ? document.referrer : window.location.href,
    iFrameClass: parent !== window ? window.frameElement.className : '',
    accessToken: null,
    authStatus: {
      isRunning: false,
      hasFailed: false,
      message: '',
      authSource: 'tinybeans'
    }
  },
  getters: {
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    iFrameParentUrl(state) {
      return state.iFrameParentUrl;
    },
    iFrameClass(state) {
      return state.iFrameClass;
    },
    accessToken(state) {
      return state.accessToken;
    },
    authStatus(state){
      return state.authStatus;
    }
  },
  mutations: {
    updateUserStatus(state) {
        state.isAuthenticated = !state.isAuthenticated;
    },
    updateAccessToken(state, accessToken) {
      state.accessToken = accessToken;
    },
    updateAuthStatus(state, payload = {}) {
      state.authStatus.isRunning = payload.isRunning;
      state.authStatus.hasFailed = payload.hasFailed;
      state.authStatus.message   = payload.message;
      state.authStatus.authSource   = payload.authSource;
    }
  },
  actions: {
    updateUserStatus(context) {
      context.commit('updateUserStatus');
    },
    updateAccessToken(context, accessToken) {
      context.commit('updateAccessToken', accessToken);
    },
    updateAuthStatus(context, payload) {
      context.commit('updateAuthStatus', payload);
    }
  }
});